import React, { ChangeEvent, ReactNode } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import checkmark from '@/public/img/icons/checkcircle.svg';

interface WizardBoxCheckboxProps {
	label: string;
	description: string;
	icon?: ReactNode;
	name: string;
	id: string;
	value: string;
	testId?: string;
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
	checked?: boolean;
	className?: string;
}

const WizardBoxCheckbox = (props: WizardBoxCheckboxProps) => {
	const {
		label,
		description,
		icon,
		testId = 'WizardBoxCheckbox',
		name,
		value,
		id,
		onChange: handleChange,
		checked,
		className,
	} = props;

	return (
		<div data-testid={testId} className={cn('relative', className)}>
			<input
				id={id}
				type="checkbox"
				name={name}
				value={value}
				className="peer sr-only"
				onChange={handleChange}
				checked={checked}
			/>
			<Image
				src={checkmark}
				alt="checkmark icon"
				className="absolute -left-3 -top-3 hidden w-6 peer-checked:block lg:w-9"
				tabIndex={-1}
			/>
			<label
				htmlFor={id}
				className={cn(
					'flex min-w-39 flex-1 rounded-xl border-2 bg-white py-4.5 pl-5 pr-6 lg:px-3 lg:py-7',
					'hover:cursor-pointer hover:border-2 hover:border-black peer-checked:border-sky-600 peer-focus:border-black',
					'peer-focus:peer-checked:border-sky-600 peer-focus:peer-checked:outline peer-focus:peer-checked:outline-sky-600',
					icon
						? 'justify-between md:flex-col-reverse md:text-center'
						: 'justify-center text-center',
				)}
			>
				<p
					className={cn('text-sm text-slate-500 lg:text-base', {
						'text-left md:text-center': icon,
					})}
				>
					<span
						className={cn(
							'block pb-1 text-black',
							icon
								? 'text-base font-bold'
								: 'text-2xl font-semibold lg:text-3xl',
						)}
					>
						{label}
					</span>
					{description}
				</p>
				{icon && (
					<div
						aria-hidden="true"
						className="self-center justify-self-center md:mb-4"
					>
						{icon}
					</div>
				)}
			</label>
		</div>
	);
};

export default WizardBoxCheckbox;
